import React, { useState, useEffect } from 'react';
import { Table, Button, Form, InputGroup, Spinner, Card, Row, Col } from 'react-bootstrap';
import { FaSearch, FaEdit, FaPlus } from 'react-icons/fa';
import servicosService from '../../api/servicosService';
import { useNavigate } from 'react-router-dom';

const ListarServicos = () => {
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const navigate = useNavigate();

  const fetchServicos = async () => {
    setLoading(true);
    try {
      const response = await servicosService.listar();
      setServicos(response);
    } catch (error) {
      console.error('Erro ao buscar serviços:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServicos();
  }, []);

  const handleSearch = (e) => {
    setBusca(e.target.value);
  };

  const servicosFiltrados = servicos?.filter((servico) =>
    servico.nome.toLowerCase().includes(busca.toLowerCase())
  );

  const handleEdit = (id) => {
    navigate(`/servicos/${id}`);
  };

  const handleNewService = () => {
    navigate('/servicos');
  };

  return (
    <div className="listar-servicos-container">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Lista de Serviços</Card.Title>
          <hr />
          <Row>
            <Col md={9} className="mb-3">
              <Form>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Buscar serviço por nome..."
                    value={busca}
                    onChange={handleSearch}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form>
            </Col>
            <Col md={3} className="text-end">
              <Button variant="success" onClick={handleNewService}>
                <FaPlus /> Novo Serviço
              </Button>
            </Col>
          </Row>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table striped bordered hover responsive className="mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Valor</th>
                  <th>Comissão Profissional</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {servicosFiltrados?.map((servico) => (
                  <tr key={servico.id}>
                    <td>{servico.nome}</td>
                    <td>{servico.valor}</td>
                    <td>{servico.comissaoProfissional}</td>
                    <td>
                      <Button
                        style={{ backgroundColor: '#840027', borderColor: '#840027' }}
                        size="sm"
                        onClick={() => handleEdit(servico.id)}
                      >
                        <FaEdit /> Editar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListarServicos;
